import React from 'react';

import { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSeparator } from 'components/ui/input-otp';

const otpSlotClassName = 'h-[50px] w-[46px] rounded-[5px] border text-xl max-[520px]:h-[46px] max-[520px]:w-[37px]';

const OTPForm = ({ value, onChange, disabled }) => {
  return (
    <div className="space-y-2">
      <InputOTP maxLength={6} value={value} onChange={onChange} disabled={disabled} containerClassName="gap-1.5">
        <InputOTPGroup className="gap-1.5">
          <InputOTPSlot index={0} className={otpSlotClassName} />
          <InputOTPSlot index={1} className={otpSlotClassName} />
          <InputOTPSlot index={2} className={otpSlotClassName} />
        </InputOTPGroup>
        <InputOTPSeparator className="text-[#61786a] [&>svg]:h-5 [&>svg]:w-5" />
        <InputOTPGroup className="gap-1.5">
          <InputOTPSlot index={3} className={otpSlotClassName} />
          <InputOTPSlot index={4} className={otpSlotClassName} />
          <InputOTPSlot index={5} className={otpSlotClassName} />
        </InputOTPGroup>
      </InputOTP>
    </div>
  );
};

export default OTPForm;
